import './Appearance.css'
import { Grid } from '@mui/material'
import EditableTheme from '../../../Components/EditableTheme/EditableTheme'

const Appearance = () => {
  return (
    <Grid container>
      <Grid item size={{ xs: 12 }}>
        <EditableTheme />
      </Grid>
    </Grid>
  )
}

export default Appearance